/* globals  ga */
itsoftApp.createModule("metriks", function() {
    var yaCounterThis;
    var module = this;

    function detectYaCounter() {
        if (typeof yaCounterThis !== "undefined" && typeof yaCounterThis !== "boolean") {
            return;
        }

        var res = undefined;

        for (var i in window) {
            if (i.indexOf("yaCounter") >= 0) {
                res = window[i];
            }
        }

        if (res !== undefined) {
            yaCounterThis = res;
        } else {
            yaCounterThis = false;
        }
    }

    detectYaCounter();

    function metriksAjaxHreh(parentsUrl, parentsUrlOld) {
        if ( typeof(yaCounterThis) !== "undefined" && typeof yaCounterThis.hit === "function" ) {
            yaCounterThis.hit(parentsUrl, {referer: parentsUrlOld });
        }

        if ( typeof(ga) !== "undefined" ) {
            ga("set", "page", parentsUrl);
            ga("send", "pageview");
        }
    }

    module.metriksAjaxHreh = metriksAjaxHreh;
});